// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__dyd2w","productName":"Table_productName__Xaa04"};